<div class="content-view">
  <lib-toastify-toast-container position="bottom-right"></lib-toastify-toast-container>
  <div class="header">
    <mat-toolbar class="header" color="primary">
      <button mat-icon-button color="white" (click)="home()">
        <mat-icon>home</mat-icon>
      </button>
      <div class="start-header">
        <h1 class="title">Diagnostic Questions</h1>
      </div>
      <div class="end-header">
        <button mat-mini-fab color="white" (click)="logout()">
          <mat-icon>logout</mat-icon>
        </button>
      </div>
    </mat-toolbar>
  </div>
</div>

<div class="component-container">
  <div class="actions-container">
    <div class="select-all-container">
      <mat-label>select all</mat-label>
      <mat-checkbox (change)="selectAll($event)"></mat-checkbox>
    </div>

    <form class="actions-filter">
      <mat-form-field class="keyword-field" appearance="outline">
        <mat-label>Palavra chave</mat-label>
        <input matInput [ngModel]="globalfilter" (ngModelChange)="applyFilter($event)"
          [ngModelOptions]="{ standalone: true }" />
      </mat-form-field>

      <mat-form-field class="filter-field" appearance="outline">
        <mat-label>CEFR</mat-label>
        <mat-select [formControl]="cefrControl">
          <mat-option>nenhum</mat-option>
          <mat-option *ngFor="let cefr of cefrs" [value]="cefr">
            {{ cefr }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="filter-field" appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select [formControl]="statusControl">
          <mat-option [value]="null">nenhum</mat-option>
          <mat-option [value]="true">
            Published
          </mat-option>
          <mat-option [value]="false">
            Not Published
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <div class="action-buttons-container">
      <div class="top-actions">
        <button mat-mini-fab color="primary" (click)="createQuestion()">
          <mat-icon>add</mat-icon>
        </button>

        <button mat-mini-fab color="white" (click)="removeSelectedQuestions()">
          <mat-icon color="primary">delete_outline</mat-icon>
        </button>

        <button mat-raised-button color="warn" (click)="publishQuestions(false)">Un-publish</button>

        <button mat-raised-button color="primary" (click)="publishQuestions(true)">Publish</button>
      </div>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <div class="questions-container" *ngIf="!loading">
    <div class="questions-grid">
      <ng-container *ngFor="let row of dataSource.filteredData">
        <div class="question-card">
          <div class="card-left-tabs">
            <button class="tab-btn" 
                    [class.active]="!selectedQuestionTab[row.uid] || selectedQuestionTab[row.uid] === 'question'"
                    (click)="setQuestionTab(row.uid, 'question')">
              <mat-icon>quiz</mat-icon>
              Question
            </button>
            <button class="tab-btn" 
                    [class.active]="selectedQuestionTab[row.uid] === 'options'"
                    (click)="setQuestionTab(row.uid, 'options')">
              <mat-icon>list</mat-icon>
              Options
            </button>
          </div>

          <div class="card-content">
            <div class="card-header">
              <div class="checkbox-wrapper">
                <mat-checkbox [checked]="questionsSelected[row.uid]" (change)="select($event, row.uid)"></mat-checkbox>
              </div>
              <div class="card-title">{{ row.name }}</div>
            </div>

            <!-- Question Tab: instructions → text → image → audio -->
            <div class="tab-content question-tab-content" *ngIf="!selectedQuestionTab[row.uid] || selectedQuestionTab[row.uid] === 'question'">
              <div class="question-blocks" *ngIf="getQuestionBlocks(row).length; else noQuestionBlocks">
                <ng-container *ngFor="let block of getQuestionBlocks(row)">
                  <h3 class="question-block-header" *ngIf="block.type === 'instructions'">{{ block.content }}</h3>
                  <p class="question-block-text" *ngIf="block.type === 'text'">{{ block.content }}</p>
                  <img *ngIf="block.type === 'image'"
                       class="question-block-image"
                       [src]="resolveImageUrl(block.content)"
                       alt="Question image"
                       width="320"
                       height="180"
                       loading="lazy"
                       (error)="onImageError($event)" />
                  <audio *ngIf="block.type === 'audio'"
                         class="question-block-audio"
                         [src]="block.content"
                         controls
                         preload="metadata"></audio>
                </ng-container>
              </div>
              <ng-template #noQuestionBlocks>
                <p class="empty-state">No question content.</p>
              </ng-template>
            </div>

            <!-- Options Tab: 2x2 images, vertical text/audio -->
            <div class="tab-content options-tab-content" *ngIf="selectedQuestionTab[row.uid] === 'options'">
              <div class="options-row"
                   [class.options-row--image]="getPrimaryOptionBlockType(row.level.options[0]) === 'image'"
                   [class.options-row--vertical]="getPrimaryOptionBlockType(row.level.options[0]) === 'text' || getPrimaryOptionBlockType(row.level.options[0]) === 'audio'"
                   *ngIf="row.level?.options?.length; else noOptions">
                <div class="option-item"
                     *ngFor="let option of row.level.options; let i = index"
                     [class.correct]="option.isCorrect">
                  <span class="option-label">{{ i + 1 }}</span>
                  <div class="option-content">
                    <ng-container *ngFor="let block of getOptionBlocks(option)">
                      <span *ngIf="block.type === 'text'" class="option-text">
                        {{ block.content }}
                      </span>
                      <img *ngIf="block.type === 'image'"
                           [src]="resolveImageUrl(block.content)"
                           [alt]="'Option ' + (i + 1)"
                           class="option-image"
                           width="80"
                           height="80"
                           loading="lazy"
                           (error)="onImageError($event)" />
                      <audio *ngIf="block.type === 'audio'"
                             class="option-audio"
                             [src]="block.content"
                             controls
                             preload="metadata"></audio>
                    </ng-container>
                  </div>
                  <div class="option-indicator" *ngIf="option.isCorrect">
                    <mat-icon>check_circle</mat-icon>
                  </div>
                </div>
              </div>
              <ng-template #noOptions>
                <p class="empty-state">No answer options.</p>
              </ng-template>
            </div>

            <div class="card-footer">
              <div class="footer-badges">
                <div class="cefr-badge">
                  <span>{{ row.cefr }}</span>
                </div>
                <div class="status-badge" [ngClass]="{ published: row.published, unpublished: !row.published }">
                  <span>{{ row.published ? 'Published' : 'Unpublished' }}</span>
                </div>
              </div>
              <div class="footer-actions">
                <button mat-icon-button color="primary" (click)="editQuestion(row)" title="Edit">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="primary" (click)="copyToClipboard(row.uid)" title="Copy ID">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <mat-paginator [pageSizeOptions]="[5, 10, 25, 50, 100]" [pageSize]="defaultPageSize" (page)="paginatorChanged($event)"
    aria-label="Select page of questions" [showFirstLastButtons]="true">
  </mat-paginator>
</div>
